import { usePageView } from '../../common/hooks/use.analytics';
import the from '../../common/objects/the';
import Form from './form';
import Div from '../../common/components/div';
import H2 from '../../common/components/h2';
import TranslatedSpan from '../../common/components/translated.span';
import local from '../../common/classes/local';
import { useAuthenticatedRedirect } from '../../common/hooks/use.authenticated.redirect';

export default function Login() {
    usePageView('Login');
    useAuthenticatedRedirect();

    const getCoronavirusSubdomain = () => {
        return local.getItem('language') === 'English' ? 'www' : 'es';
    };

    return <>
        <div style={{backgroundColor: the.color.white}}>
            <div style={{backgroundColor: the.color.bannerBlue}}>
                <Div isContainer={true}>
                    <Div isRow={true}>
                        <Div
                            cols={12}
                            paddingBottom={5} paddingLeft={7} paddingRight={7} paddingTop={5}
                        >
                            <Div
                                paddingRight={0} paddingRightMD={3} paddingRightLG={5} paddingRightXL={7}
                                style={{display: 'inline-block'}}
                            >
                                <H2 style={{color: the.color.white}}>
                                    <TranslatedSpan english={'See how Medicare is responding to Coronavirus'}/>
                                </H2>
                            </Div>
                            <Div style={{display: 'inline-block'}}>
                                <a
                                    className={'ds-c-button'}
                                    href={`https://${getCoronavirusSubdomain()}.medicare.gov/medicare-coronavirus`}
                                    rel={'noopener noreferrer'}
                                    style={{
                                        paddingLeft: 65,
                                        paddingRight: 65,
                                        whiteSpace: 'nowrap',
                                    }}
                                    target={'_blank'}
                                >
                                    <TranslatedSpan english={'Learn more'}/>
                                    <span className={'sr-only'}><TranslatedSpan english={'This link opens a new window or tab.'}/></span>
                                </a>
                            </Div>
                        </Div>
                    </Div>
                </Div>
            </div>
            <Form/>
        </div>
    </>;
}